import {useEffect, useState} from 'react';

const BASE = process.env.REACT_APP_AWP_API_URL || 'https://awp.minsky.ai';

function authHeaders() {
    const token = localStorage.getItem('access_token');
    return token ? {'Authorization': `Bearer ${token}`} : {};
}

/**
 * Fetches the three KB tier totals (approved, candidates, mentions) in a single
 * request so the tab badges are populated immediately on page load, before the
 * user visits each tab.
 *
 * @returns {{ approved: number, candidates: number, mentions: number, loading: boolean }}
 */
export function useEntityTierCounts() {
    const [counts, setCounts]   = useState({approved: 0, candidates: 0, mentions: 0, noQid: 0});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        setLoading(true);

        fetch(`${BASE}/api/documents/entity-tier-counts`, {headers: authHeaders()})
            .then(r => r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`)))
            .then(data => {
                if (!cancelled) {
                    setCounts({
                        approved:   Number(data.approved)   || 0,
                        candidates: Number(data.candidates) || 0,
                        mentions:   Number(data.mentions)   || 0,
                        noQid:      Number(data.noQid)      || 0,
                    });
                }
            })
            .catch(() => { /* non-fatal — tab badges just start at 0 */ })
            .finally(() => { if (!cancelled) setLoading(false); });

        return () => { cancelled = true; };
    }, []);

    return {...counts, loading};
}
